import { All_TASK_LIST_REQUESTED,
    All_TASK_LIST_RECEIVED,
    All_TASK_LIST_ERROR,

    } from "../actions/bpmnAllTaskList";
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
*
* @param {RequestResult} state
* @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
* @return {RequestResult}
*/
export const alltaskList = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

switch (action.type) {
   case All_TASK_LIST_REQUESTED:
       return new RequestResult(RequestState.getInstanceLoading(), state.data);
   case All_TASK_LIST_RECEIVED:
       return new RequestResult(RequestState.getInstanceDone(), action.alltaskList, action.receivedAt);
   case All_TASK_LIST_ERROR:
       return new RequestResult(
           RequestState.getInstanceError(
               action.errorResponseStatusCode,
               action.errorResponseMessage ? action.errorResponseMessage : null
           ),
           state.getData()
       );
 
   default:
       return state
}
};
